import React, { useState, useEffect } from 'react';
import { Cookie, Shield, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent && !isDismissed) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isDismissed]);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    setIsDismissed(true);
    // You can add analytics tracking here
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
    setIsDismissed(true);
  };

  const handleClose = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50" style={{ backgroundColor: '#1a1b20' }}>
      {/* Bright blue separator line */}
      <div className="w-full h-0.5" style={{ backgroundColor: '#00ffff' }}></div>
      
      <div className="container mx-auto px-4 py-3">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          {/* Left Section - Content */}
          <div className="flex-1 flex items-start gap-4">
            {/* Cookie Icon */}
            <div className="flex-shrink-0">
              <div className="w-10 h-10 rounded-full border-2 flex items-center justify-center" style={{ backgroundColor: '#1a1b20', borderColor: '#00ffff' }}>
                <Cookie className="w-5 h-5" style={{ color: '#00ffff' }} />
              </div>
            </div>
            
            {/* Text Content */}
            <div className="flex-1 min-w-0">
              <h3 className="text-white font-bold text-base mb-1 uppercase tracking-wide">
                We Use Cookies
              </h3>
              <p className="text-white text-sm mb-2 leading-relaxed" style={{ color: '#d1d5db' }}>
                We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
                By clicking "Accept All", you consent to our use of cookies.
              </p>
              <div className="flex items-center gap-2 text-xs">
                <Shield className="w-3 h-3 text-white" />
                <span className="text-white" style={{ color: '#d1d5db' }}>Secure & GDPR Compliant</span>
                <Link 
                  to="/cookies-policy" 
                  className="underline transition-colors"
                  style={{ color: '#00ffff' }}
                >
                  Learn more in our Cookies Policy.
                </Link>
              </div>
            </div>
          </div>

          {/* Right Section - Buttons */}
          <div className="flex-shrink-0 flex items-center gap-3">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-white text-sm font-medium uppercase tracking-wide transition-colors focus:outline-none"
              style={{ 
                backgroundColor: '#1a1b20', 
                border: '1px solid #00ffff',
                color: '#d1d5db'
              }}
            >
              Decline All
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-white text-sm font-medium uppercase tracking-wide transition-colors focus:outline-none"
              style={{ 
                backgroundColor: '#00ffff',
                color: '#1a1b20',
                border: '1px solid #00ffff'
              }}
            >
              Accept All
            </button>
            
            {/* Close Button */}
            <button
              onClick={handleClose}
              className="p-2 transition-colors focus:outline-none"
              style={{ color: '#d1d5db' }}
              aria-label="Close cookie banner"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
